import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import Layout from '../../Layout';
import PatientsNoDataBox from '../../components/CustomUI/PatientsNoDataBox';
import PatientTable from '../../components/PatientTable';
import { getServiceUrl } from '../../config';

const API_BASE_URL = getServiceUrl();

function Patients() {
  const [patientsData, setPatientsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  async function getPatientsData() {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}patient/patientdetails`,
        {
          headers: {
            rdxtoken: localStorage.getItem('tokenId'),
          },
        },
      );
      setPatientsData(response.data);
    } catch (error) {
      console.error('Error fetching patient details!', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      try {
        await getPatientsData();
      } catch (error) {
        console.error('Error fetching data!', error);
      }
    })();
  }, []);

  // Preview patient details
  const previewPatient = (id) => {
    navigate(`/patients/${id}`);
  };

  return (
    <Layout>
      <div className="mx-auto max-w-7xl px-4 py-4">
        {loading ? (
          <div className="flex h-64 items-center justify-center rounded-lg bg-white">
            <div className="flex items-center gap-3">
              <div className="h-5 w-5 animate-spin rounded-full border-2 border-blue-600 border-t-transparent"></div>
              <span className="text-sm text-gray-600">Loading patients...</span>
            </div>
          </div>
        ) : patientsData.length > 0 ? (
          <>
            <div className="mb-6 flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-semibold text-gray-900">Patients</h1>
                <p className="mt-1 text-sm text-gray-600">Manage and monitor your patients</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2 rounded-lg bg-blue-50 px-3 py-2">
                  <span className="text-sm font-medium text-blue-700">Total Patients:</span>
                  <span className="text-sm font-bold text-blue-900">{patientsData.length}</span>
                </div>
                <Link
                  to="/patients/create"
                  className="inline-flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  Add Patient
                </Link>
              </div>
            </div>
            <div className="mt-4">
              <PatientTable
                data={patientsData}
                functions={{ preview: previewPatient }}
              />
            </div>
          </>
        ) : (
          <PatientsNoDataBox
            message="No patients found."
            buttonLabel="Add Patient"
            buttonLink="/patients/create"
          />
        )}
      </div>
    </Layout>
  );
}

export default Patients;
